import React, { createContext, useContext, useState } from 'react'

const LayoutContext = createContext({})

const useLayoutContext = () => {
  const context = useContext(LayoutContext)
  if (!context) {
    throw new Error('Cannot use LayoutContext outside LayoutContextProvider!')
  }
  return context
}

const LayoutContextProvider = ({ children }) => {
  const [qs, setQs] = useState({})
  const [paginate, setPaginate] = useState({})

  const getSearch = (key) => {
    return qs[key]
  }

  const setSearch = (key, value) => {
    setQs({
      ...qs,
      [key]: value
    })
  }

  const getPageNo = (key) => {
    return paginate[key]
  }

  const onPageChange = (key, page) => {
    setPaginate({
      ...paginate,
      [key]: page
    })
  }

  const contextValue = {
    getSearch,
    setSearch,
    getPageNo,
    onPageChange
  }
  return (
    <LayoutContext.Provider value={contextValue}>
      {children}
    </LayoutContext.Provider>
  )
}

export default LayoutContextProvider
export {
  useLayoutContext
}
